import { DaoService } from './../servicos/dao.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-licitacao-view',
  templateUrl: './licitacao-view.component.html',
  styleUrls: ['./licitacao-view.component.css']
})
export class LicitacaoViewComponent implements OnInit {

  constructor(public dao:DaoService,private route: ActivatedRoute) { }

  categoria:any;
  sub: any;
  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.categoria = params['categoria']; // (+) converts string 'id' to a number

      // In a real app: dispatch action to load the details here.
      this.nenhuma = true;
      this.listar();
   });
    
  }

  licitacoes:any;
  passadas:any;
  nenhuma: boolean = true;

  listar(){
    this.licitacoes = [];
    this.passadas = [];
    this.dao.submeter({},"listarLicitacoes").then(res=>{
      if(!res.length){
        this.nenhuma = true;
        return;
      }
      this.licitacoes = res.filter(l=>{
        
        if(l.finalizado=='sim' && l.categoria==this.categoria)this.passadas.push(l);
        if(l.finalizado=='nao' && l.categoria==this.categoria)return l;
      });

      if(this.licitacoes.length || this.passadas.length)this.nenhuma = false;

    })

  }

}
